import * as React from 'react'

import { AuthProvider } from '../auth/AuthProvider'
import { ClientGqlProvider } from '../graphQL/ClientGqlProvider'
import { I18nProvider } from '../i18n/I18nProvider'
import type { TClientAppRootProps } from './AppRoot'

export const ClientAppRoot: React.FC<TClientAppRootProps> = ({
  children,
  backendUrl,
  activeLocale,
  localeCatalogs,
  isLoginEnabled,
  loadingFallback,
  initAuthContext,
  onAuthContextChange,
}) => {
  return (
    <React.Suspense fallback={loadingFallback ?? <b>Loading...</b>}>
      <AuthProvider
        backendUrl={backendUrl}
        initContext={initAuthContext}
        onContextChange={onAuthContextChange}
        activeLocale={activeLocale}
        isLoginEnabled={isLoginEnabled}
      >
        <ClientGqlProvider backendUrl={backendUrl} activeLocale={activeLocale}>
          <I18nProvider initialLocale={activeLocale} catalogs={localeCatalogs}>
            {children}
          </I18nProvider>
        </ClientGqlProvider>
      </AuthProvider>
    </React.Suspense>
  )
}
